import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { Routes } from '@angular/router';
import { ComparePageComponent } from './pages/compare-page/compare-page.component';

export const CompareRoutes: Routes = [
  {
    path: CatalogRouting.compareDefaultPath,
    component: ComparePageComponent
  }
];
